import { render, staticRenderFns } from "./inspectionStatistics.vue?vue&type=template&id=34f2989a&scoped=true&"
import script from "./inspectionStatistics.vue?vue&type=script&lang=js&"
export * from "./inspectionStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f2989a",
  null
  
)

export default component.exports